import LiquidText from './LiquidText';
import { LiquidDialog } from './LiquidUI';
import React, { useState } from 'react';
import api from '../services/api';

/* O envelope de uma linha: diz que já se avisou, quantas vezes, e abre o
   histórico ao ser clicado.

   Porque é que a contagem importa: insistir é normal — quem não responde à
   primeira leva segunda e terceira. Guardar só a última data apagava a prova de
   que se insistiu, que é precisamente o que se quer mostrar a quem diga que
   nunca foi avisado. Por isso cada envio fica registado com o dia e a hora.
   ============================================================ */
const HistoricoEnvios = ({ despesaId, transacaoId, quantos }) => {
    const [aberto, setAberto] = useState(false);
    const [envios, setEnvios] = useState(null);
    const [erro, setErro] = useState('');

    const abrir = async (e) => {
        e.stopPropagation();
        setAberto(true); setErro('');
        try {
            const r = await api.get('/combustivel/envios', {
                params: despesaId ? { despesa_id: despesaId } : { transacao_id: transacaoId },
            });
            setEnvios(r.data || []);
        } catch (err) { setErro(err.response?.data?.error || err.message); }
    };

    const quando = (d) => new Date(d).toLocaleString('pt-PT', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });

    /* A contagem vai sobreposta ao canto do envelope, à maneira dos avisos, e
       aparece a partir do primeiro envio: quem olha para a linha quer saber
       quantas vezes já se pediu sem ter de abrir nada. Antes era um sobrescrito
       ao lado e só a partir do segundo envio, o que deixava o caso mais comum —
       avisado uma vez — sem número nenhum. O aro branco é o que descola o
       número do desenho do emoji. */
    const n = Number(quantos) || 0;

    return (
        <>
            <button onClick={abrir}
                title={n ? `${n} ${n === 1 ? 'mensagem enviada' : 'mensagens enviadas'} — ver as datas`
                         : 'Ver os envios feitos'}
                style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0,
                    color: '#166534', fontSize: '0.95rem', whiteSpace: 'nowrap',
                    position: 'relative', display: 'inline-block', lineHeight: 1 }}><LiquidText>
                ✉️
                </LiquidText>{n > 0 && (
                    <span style={{ position: 'absolute', top: -5, right: -7,
                        minWidth: 14, height: 14, padding: '0 3px', boxSizing: 'border-box',
                        borderRadius: 7, border: '1px solid #fff', background: '#166534',
                        color: '#fff', fontSize: '0.6rem', fontWeight: 700, lineHeight: '12px' }}>
                        {n}
                    </span>
                )}
            </button>

            {aberto && (
                <LiquidDialog onClose={() => setAberto(false)} onClick={(e) => { e.stopPropagation(); setAberto(false); }}
                    style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 2100,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
                    <div data-liquid-surface="true" onClick={e => e.stopPropagation()}
                        style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', width: 300,
                            maxWidth: '94vw', maxHeight: '80vh', overflowY: 'auto', textAlign: 'center' }}>
                        <h3 style={{ margin: '0 0 10px', fontSize: '1rem' }}>
                            Mensagens enviadas{envios ? `: ${envios.length}` : ''}
                        </h3>
                        {erro && <p style={{ color: '#b91c1c', fontSize: '0.85rem' }}>{erro}</p>}
                        {!envios && !erro && <p style={{ color: '#64748b', fontSize: '0.85rem' }}>A carregar…</p>}
                        {envios?.length === 0 && <p style={{ color: '#64748b', fontSize: '0.85rem' }}>Ainda não foi enviada nenhuma.</p>}
                        {envios?.map((e, i) => (
                            <div key={e.id} style={{ borderTop: i ? '1px solid #f1f5f9' : 'none',
                                padding: '7px 0', fontSize: '0.85rem' }}>
                                {quando(e.enviado_em)}
                            </div>
                        ))}
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 14 }}>
                            <button className="btn-secondary" onClick={() => setAberto(false)}>Fechar</button>
                        </div>
                    </div>
                </LiquidDialog>
            )}
        </>
    );
};

export default HistoricoEnvios;
